import "./HomePage.scss";
import { useEffect, useRef, useState, lazy, Suspense } from "react"; 
import {
  API_END_POINTS,
  AUTHENTICATION,
  GLOBAL_CONSTANTS,
  HOMEPAGE,
  ROUTES,
} from "../../Constants/Constants";
import { Skeleton, Autocomplete, TextField, createFilterOptions } from "@mui/material"; 
import search from "../../Assets/home/searchPink.svg";
import school from "../../Assets/home/school.svg";
import university from "../../Assets/home/university.svg";
import themePark from "../../Assets/home/themeParks.svg";
import playStore from "../../Assets/home/playStore.svg";
import appStore from "../../Assets/home/appStore.svg";
import tutor from "../../Assets/home/tutor.svg";
import activities from "../../Assets/home/activities.svg";
import { axiosInstance } from "../../Utilities/Interceptor/Interceptor";
import { useNavigate, useLocation } from "react-router-dom";
import { GetSessionStorageData, nullUndefinedEmptyCheck } from "../../Utilities/Helpers/Helper";
import axios from "axios";
import { useSelector } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/grid";
import { Autoplay, Pagination, Mousewheel, Keyboard } from "swiper/modules";
import { useTranslation } from "react-i18next";
import ThemePark__gird from "../../Assets/SideBar/themeParkActive.svg";
import University__gird from "../../Assets/University/universityIcon.svg";


const HomeOffersCarousel = lazy(() => import("./../../Components/HomeOffersCarousel/HomeOffersCarousel"));
const HomeServiceCards = lazy(() => import("../../Components/HomeServiceCards/HomeServiceCards"));
const TopServiceCards = lazy(() => import("../../Components/TopServiceCards/TopServiceCards"));


const HomePage = () => {
  const { t } = useTranslation();
  const [searchValue, setSearchValue] = useState("");
  const [headerData, setHeaderData] = useState<any>({});
  const [schoolData, setSchoolData] = useState<any>("");
  const [universityData, setUniversityData] = useState<any>("");
  const [activitiesData, setActivitiesData] = useState<any>("");
  const [themeParksData, setThemeParksData] = useState<any>("");
  const [tutorsData, setTutorsdata] = useState<any>("");
  const [trainersData, setTrainersData] = useState<any>("");
  const [mousePosition, setMousePosition] = useState({ x: null, y: null });
  const [isTutorContentOverlapping, setIsTutorContentOverlapping] = useState(false);
  const [isActivitiesContentOverlapping, setIsActivitiesContentOverlapping] = useState(false);
  const [isLoading, setIsLoading] = useState(true); 
  const topServiceCursor = useRef<HTMLDivElement>(null);
  const filter = createFilterOptions();
  const navigate = useNavigate();
  const route = useLocation();
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const HeaderLoction: any = useSelector((state: any) => state.locationReducer.location);
  const HeaderLocationName: any = useSelector((state: any) => state.locationNameReducer.locationName);
  const language: any = useSelector((state: any) => state.languageReducer.language);

  const [searchTextList, setSearchTextList] = useState<any>([]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const token = GetSessionStorageData(AUTHENTICATION.SHARED.ACCESS_TOKEN);
    if (token && GetSessionStorageData(AUTHENTICATION.SHARED.ACCOUNT_TYPE) === AUTHENTICATION.PROFILE_ACCOUNT_TYPE.PARENT) {
      axiosInstance
        .get(`${API_END_POINTS.PREFERENCE_SELECTED_LIST}`)
        .then((response: any) => {
          const data = response?.data?.result?.data[0];
          getHomePageData(data);
        })
        .catch((error) => {
          console.error("Preference API error:", error);
          getHomePageData("");
        });
    } else {
      getHomePageData("");
    }
  }, [HeaderLoction, HeaderLocationName, route?.state?.Preference]);

  const getHomePageData = (data: any) => {
    setIsLoading(true);
    const payload = {
      tutor: data?.tutor ?? [],
      recreationalpersonal: data?.recreationalpersonal ?? [],
      recreationalcamp: data?.recreationalcamp ?? [],
      school: data?.school ?? [],
      university: data?.university ?? [],
      lat: HeaderLoction?.lat?.toString(),
      lng: HeaderLoction?.lng?.toString(),
    };

    axiosInstance
      .post(`${API_END_POINTS.HOMEPAGE}`, route?.state?.Preference || payload)
      .then((homePageResponse: any) => {
        if (homePageResponse.data[AUTHENTICATION.SHARED.STATUS] === AUTHENTICATION.SHARED.TRUE) {
          const responseData = homePageResponse?.data?.result?.data[0];
          setHeaderData(responseData?.header?.[0] || {});
          setSchoolData(responseData?.school_section || "");
          setUniversityData(responseData?.university_section || "");
          setActivitiesData(responseData?.activities_section || "");
          setThemeParksData(responseData?.themepark_section || "");
          setTutorsdata(responseData?.tutor_section || "");
          setTrainersData(responseData?.trainer_section || "");
        } else {
          console.error("Invalid API response:", homePageResponse);
          setHeaderData({});
        }
      })
      .catch((error) => {
        console.error("Homepage API error:", error);
        setHeaderData({});
      })
      .finally(() => {
        setIsLoading(false); 
      });
  };

  const positionElement = (e: any) => {
    setMousePosition({ x: e.pageX, y: e.pageY });
  };

  const handleMouseLeave = () => {
    setMousePosition({ x: null, y: null });
  };

  const handleTopServiceCursor = () => {
    if (topServiceCursor && topServiceCursor.current) {
      topServiceCursor.current.style.display = "flex";
      topServiceCursor.current.style.opacity = "1";
      topServiceCursor.current.style.transition =
        "opacity 0.2s cubic-bezier(0.28, 0.44, 0.49, 1) 0.2s,background 0.2s cubic-bezier(0.28, 0.44, 0.49, 1) 0s";
    }
  };

  const handleTopServiceCursorLeave = () => {
    if (topServiceCursor && topServiceCursor.current) {
      topServiceCursor.current.style.display = "none";
      topServiceCursor.current.style.opacity = "0";
      topServiceCursor.current.style.transition =
        "opacity 0.2s cubic-bezier(0.28, 0.44, 0.49, 1) 0.2s,background 0.2s cubic-bezier(0.28, 0.44, 0.49, 1) 0s";
    }
  };

  const searchHomeKeyword = (search: any) => {
    const url = `${process.env.REACT_APP_BASE_BACKEND_API_URL}${API_END_POINTS.HOME_SEARCH_USER}${search.trim()}`;
    axios
      .get(url)
      .then((response: any) => {
        setSearchTextList(response?.data?.result?.data || []);
      })
      .catch((error) => {
        console.error("Search API error:", error);
        setSearchTextList([]);
      });
  };

  const onInputChange = (value: any) => {
    if (nullUndefinedEmptyCheck(value)) {
      setSearchValue(value);
      searchHomeKeyword(value);
      setHighlightedIndex(-1);
    } else {
      setSearchTextList([]);
      setSearchValue("");
    }
  };

  const handleSelectValue = (val: any) => {
    if (!val) return;
    if (val?.provider_id === GLOBAL_CONSTANTS.INITIAL_VALUES.ONE_INT) {
      navigate(ROUTES.TUTORS_LIST_VIEW, {
        state: {
          tutor_list: null,
          search_text: val?.tag,
          map_show: val?.tag?.includes(GLOBAL_CONSTANTS.INITIAL_VALUES.NEAR_ME),
          redius: GLOBAL_CONSTANTS.INITIAL_VALUES.FIVE_INT,
          lat: HeaderLoction?.lat,
          lang: HeaderLoction?.lng,
        },
      });
    } else if (val?.provider_id === GLOBAL_CONSTANTS.INITIAL_VALUES.TWO_INT) {
      navigate(ROUTES.ACTIVITY_LIST_VIEW, {
        state: {
          activities_list: null,
          search_text: val?.tag,
          redius: GLOBAL_CONSTANTS.INITIAL_VALUES.FIVE_INT,
          map_show: val?.tag?.includes(GLOBAL_CONSTANTS.INITIAL_VALUES.NEAR_ME),
        },
      });
    } else if (val?.provider_id === GLOBAL_CONSTANTS.INITIAL_VALUES.THREE_INT) {
      navigate(ROUTES.ACTIVITY_LIST_VIEW, {
        state: {
          activities_list: null,
          search_text: val?.tag,
          redius: GLOBAL_CONSTANTS.INITIAL_VALUES.FIVE_INT,
          map_show: val?.tag?.includes(GLOBAL_CONSTANTS.INITIAL_VALUES.NEAR_ME),
        },
      });
    } else if (val?.provider_id === GLOBAL_CONSTANTS.INITIAL_VALUES.FOUR_INT) {
      navigate(ROUTES.SCHOOL_LIST_VIEW, {
        state: {
          school_list: null,
          search_text: val?.tag,
          redius: GLOBAL_CONSTANTS.INITIAL_VALUES.FIVE_INT,
          map_show: val?.tag?.includes(GLOBAL_CONSTANTS.INITIAL_VALUES.NEAR_ME),
        },
      });
    } else if (val?.provider_id === GLOBAL_CONSTANTS.INITIAL_VALUES.FIVE_INT) {
      navigate(ROUTES.UNIVERSITY_LIST_VIEW, {
        state: {
          university_list: null,
          search_text: val?.tag,
          redius: GLOBAL_CONSTANTS.INITIAL_VALUES.FIVE_INT,
          map_show: val?.tag?.includes(GLOBAL_CONSTANTS.INITIAL_VALUES.NEAR_ME),
        },
      });
    } else if (val?.provider_id === GLOBAL_CONSTANTS.INITIAL_VALUES.SIX_INT) {
      navigate(ROUTES.THEMEPARK_LAYOUT, {
        state: { search: val?.tag },
      });
    }
  };

  const handleKeyDown = (e: any) => {
    if (e.key === GLOBAL_CONSTANTS.INITIAL_VALUES.DOWN_ARROW) {
      setHighlightedIndex((prevIndex) =>
        prevIndex < searchTextList.length - 1 ? prevIndex + 1 : prevIndex
      );
    } else if (e.key === GLOBAL_CONSTANTS.INITIAL_VALUES.UP_ARROW) {
      setHighlightedIndex((prevIndex) =>
        prevIndex > 0 ? prevIndex - 1 : prevIndex
      );
    }
  };

  const wrapperClassName = language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "top_activities_service_cards_wrapper" : "top_activities_service_cards_wrapper-arab";
  const top_service_card_title_container_wrap = language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "top_service_card_title_container_eng" : "top_service_card_title_container-arab";
  const top_service_title_wrap = language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "top_service_title_wrapper" : "top_service_title_wrapper-arab";
  const service_title_container_wrap = language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "service_card_title_container" : "service_card_title_container-arab";
  const theme_park_background_circle_wrap = language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "theme_park_background_circle_container" : "theme_park_background_circle_container-arab";
  const school_background_circle_wrap = language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "school_background_circle_container" : "school_background_circle_container-arab";
  const activities_background_circle_wrap = language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "activities_background_circle_container" : "activities_background_circle_container-arab";
  const university_background_circle_wrap = language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "university_background_circle_container" : "university_background_circle_container-arab";
  const search_button_lang_wrap = language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "search_button" : "search_button-arab";
  const search_field_lang_wrap = language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "search_field" : "search_field-arab";

  
  const BannerSkeleton = () => (
    <div className="search_banner_container">
      <Skeleton variant="rectangular" height={330} width="100%" />
      <div className="search_field_wrapper">
        <Skeleton variant="text" width={200} height={30} />
        <Skeleton variant="text" width={300} height={40} />
        <Skeleton variant="rectangular" width={400} height={50} />
      </div>
    </div>
  );

  const ServiceNavSkeleton = () => (
    <div className="service_navigation_card_wrapper" style={{ display: "flex", gap: "20px" }}>
      {Array(5)
        .fill(0)
        .map((_, index) => (
          <div className="service_navigation_card_container" key={index}>
            <Skeleton variant="circular" width={60} height={60} />
            <div className="service_nav_title_descriptions_container">
              <Skeleton variant="text" width={100} height={20} />
              <Skeleton variant="text" width={150} height={15} />
            </div>
          </div>
        ))}
    </div>
  );

  const OffersCarouselSkeleton = () => (
    <div className="offers_carousel_wrapper">
      <Skeleton variant="rectangular" height={150} width="100%" />
    </div>
  );

  const ServiceCardsSkeleton = () => (
    <div className="school_service_cards_wrapper" style={{ display: "flex", gap: "20px" }}>
      {Array(3)
        .fill(0)
        .map((_, index) => (
          <div key={index}>
            <Skeleton variant="rectangular" height={200} width={300} />
            <Skeleton variant="text" width={200} height={20} style={{ marginTop: "10px" }} />
            <Skeleton variant="text" width={250} height={15} />
          </div>
        ))}
    </div>
  );

  const TopServiceCardsSkeleton = () => (
    <div className="top_activities_service_cards_wrapper" style={{ display: "flex", gap: "20px" }}>
      {Array(3)
        .fill(0)
        .map((_, index) => (
          <div key={index}>
            <Skeleton variant="rectangular" height={250} width={350} />
            <Skeleton variant="text" width={200} height={20} style={{ marginTop: "10px" }} />
            <Skeleton variant="text" width={300} height={15} />
          </div>
        ))}
    </div>
  );

  const MobileAppAdSkeleton = () => (
    <div className="mobile_app_ad_wrapp" style={{ display: "flex", gap: "20px" }}>
      <Skeleton variant="rectangular" height={200} width="50%" />
      <div className="mobile_app_links_wrapper">
        <Skeleton variant="rectangular" width={150} height={40} />
        <Skeleton variant="text" width={200} height={30} style={{ marginTop: "10px" }} />
        <Skeleton variant="text" width={300} height={20} style={{ marginTop: "10px" }} />
        <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
          <Skeleton variant="rectangular" width={120} height={40} />
          <Skeleton variant="rectangular" width={120} height={40} />
        </div>
      </div>
    </div>
  );

  return (
    <div className="home_page_wrapper">
      {isLoading ? (
        <>
          <BannerSkeleton />
          <ServiceNavSkeleton />
          <OffersCarouselSkeleton />
          <div className="service_card_title_wrapper">
            <Skeleton variant="text" width={200} height={30} />
            <ServiceCardsSkeleton />
          </div>
          <div className="top_service_card_title_wrapper">
            <Skeleton variant="text" width={200} height={30} />
            <TopServiceCardsSkeleton />
          </div>
          <div className="service_card_title_wrapper">
            <Skeleton variant="text" width={200} height={30} />
            <ServiceCardsSkeleton />
          </div>
          <div className="top_service_card_title_wrapper">
            <Skeleton variant="text" width={200} height={30} />
            <TopServiceCardsSkeleton />
          </div>
          <div className="service_card_title_wrapper">
            <Skeleton variant="text" width={200} height={30} />
            <ServiceCardsSkeleton />
          </div>
          <div className="service_card_title_wrapper university_label">
            <Skeleton variant="text" width={200} height={30} />
            <ServiceCardsSkeleton />
          </div>
          <MobileAppAdSkeleton />
        </>
      ) : (
        <Suspense fallback={<>
          <BannerSkeleton />
          <ServiceNavSkeleton />
          <OffersCarouselSkeleton />
          <div className="service_card_title_wrapper">
            <Skeleton variant="text" width={200} height={30} />
            <ServiceCardsSkeleton />
          </div>
          <div className="top_service_card_title_wrapper">
            <Skeleton variant="text" width={200} height={30} />
            <TopServiceCardsSkeleton />
          </div>
          <div className="service_card_title_wrapper">
            <Skeleton variant="text" width={200} height={30} />
            <ServiceCardsSkeleton />
          </div>
          <div className="top_service_card_title_wrapper">
            <Skeleton variant="text" width={200} height={30} />
            <TopServiceCardsSkeleton />
          </div>
          <div className="service_card_title_wrapper">
            <Skeleton variant="text" width={200} height={30} />
            <ServiceCardsSkeleton />
          </div>
          <div className="service_card_title_wrapper university_label">
            <Skeleton variant="text" width={200} height={30} />
            <ServiceCardsSkeleton />
          </div>
          <MobileAppAdSkeleton />
        </> 
        }>
          <div className="search_banner_container">
            {headerData?.banner?.length > 0 && (
              <Swiper
                pagination={{ dynamicBullets: true, clickable: true }}
                autoplay={{ delay: 2500, disableOnInteraction: false }}
                keyboard={true}
                modules={[Autoplay, Mousewheel, Keyboard]}
                className="mySwiper"
              >
                {headerData.banner.map((imageSrc: any, index: any) => (
                  <SwiperSlide key={index}>
                    <img src={imageSrc} alt="Learn and Play" className="banner_image" />
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
            <div className="search_field_wrapper">
              <div className="top__banner__contant_whiteText">{t("we’re more than an app -")}</div>
              <div className="top__banner__contant_blackText">{t("a platform that empowers, a movement that inspires")}</div>
              <div className="search_field_container">
                <input
                  placeholder={t("Search anything here...")}
                  type="text"
                  className={search_field_lang_wrap}
                  value={highlightedIndex !== -1 ? searchTextList[highlightedIndex]?.tag || searchValue : searchValue}
                  onChange={(inputChangeEvent: any) => onInputChange(inputChangeEvent.target.value)}
                  onKeyDown={handleKeyDown}
                  onKeyPress={(e: any) => {
                    if (e.code === GLOBAL_CONSTANTS.INITIAL_VALUES.ENTER) {
                      if (searchValue.trim() === "") {
                        e.preventDefault();
                      } else {
                        handleSelectValue(highlightedIndex !== -1 ? searchTextList[highlightedIndex] : searchTextList[0]);
                        e.preventDefault();
                      }
                    }
                  }}
                />
                <img
                  draggable="false"
                  src={search}
                  alt="Learn and Play"
                  className={search_button_lang_wrap}
                  onClick={() => handleSelectValue(highlightedIndex !== -1 ? searchTextList[highlightedIndex] : searchTextList[0])}
                />
              </div>
              {nullUndefinedEmptyCheck(searchValue) && (
                <div className="Autocompleted__data_wapper">
                  {searchTextList?.map((item: any, i: any) => (
                    <div
                      className={highlightedIndex === i ? "data_wapper__box data_wapper__box_hilight" : "data_wapper__box"}
                      key={i}
                      onClick={() => handleSelectValue(item)}
                    >
                      <div className="box">
                        <span className="tag">{item?.tag}</span>
                        <span className="addon">in {item.addon_name}</span>
                      </div>
                      <div className="provider">{item.provider}</div>
                    </div>
                  ))}
                  {searchTextList?.length === 0 && (
                    <div className="no__result_wapper__box">
                      <div className="no__result">{t("No result Found")}</div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="service_navigation_card_wrapper">
            {headerData?.card?.map((serviceNavElements: any, index: any) => (
              <div className="service_navigation_card_container" key={index}>
                {serviceNavElements.name === HOMEPAGE.SERVICE_TYPE.SCHOOL && (
                  <>
                    <div className="school_nav_icon_wrapper" onClick={() => navigate(ROUTES.SCHOOLLAYOUT)}>
                      <img draggable="false" src={serviceNavElements.icon} alt="Learn and Play" className="service_nav_icon" />
                    </div>
                    <div className="service_nav_title_descriptions_container" onClick={() => navigate(ROUTES.SCHOOLLAYOUT)}>
                      <div className="service_nav_title">{serviceNavElements.name}</div>
                      <div className="service_nav_description">{t("World of Schools")}</div>
                    </div>
                  </>
                )}
                {serviceNavElements.name === HOMEPAGE.SERVICE_TYPE.TUTOR && (
                  <>
                    <div className="tutor_nav_icon_wrapper" onClick={() => navigate(ROUTES.TUTORS)}>
                      <img draggable="false" src={serviceNavElements.icon} alt="Learn and Play" className="service_nav_icon" />
                    </div>
                    <div className="service_nav_title_descriptions_container" onClick={() => navigate(ROUTES.TUTORS)}>
                      <div className="service_nav_title">{serviceNavElements.name}</div>
                      <div className="service_nav_description">{t("World of Tutors")}</div>
                    </div>
                  </>
                )}
                {serviceNavElements.name === HOMEPAGE.SERVICE_TYPE.ACTIVITIES && (
                  <>
                    <div className="activities_nav_icon_wrapper" onClick={() => navigate(ROUTES.ACTIVITYLAYOUT)}>
                      <img draggable="false" src={serviceNavElements.icon} alt="Learn and Play" className="service_nav_icon" />
                    </div>
                    <div className="service_nav_title_descriptions_container" onClick={() => navigate(ROUTES.ACTIVITYLAYOUT)}>
                      <div className="service_nav_title">{serviceNavElements.name}</div>
                      <div className="service_nav_description">{t("World of Activities")}</div>
                    </div>
                  </>
                )}
                {serviceNavElements.name === HOMEPAGE.SERVICE_TYPE.PARKS && (
                  <>
                    <div className="theme_park_nav_icon_wrapper" onClick={() => navigate(ROUTES.THEMEPARK__HOMEPAGE)}>
                      <img draggable="false" src={serviceNavElements.icon} alt="Learn and Play" className="service_nav_icon" />
                    </div>
                    <div className="service_nav_title_descriptions_container" onClick={() => navigate(ROUTES.THEMEPARK__HOMEPAGE)}>
                      <div className="service_nav_title">{serviceNavElements.name}</div>
                      <div className="service_nav_description">{t("World of Theme parks")}</div>
                    </div>
                  </>
                )}
                {serviceNavElements.name === HOMEPAGE.SERVICE_TYPE.UNIVERSITY && (
                  <>
                    <div className="university_nav_icon_wrapper" onClick={() => navigate(ROUTES.UNIVERSITYLAYOUT)}>
                      <img draggable="false" src={serviceNavElements?.icon} alt="Learn and Play" className="service_nav_icon" />
                    </div>
                    <div className="service_nav_title_descriptions_container" onClick={() => navigate(ROUTES.UNIVERSITYLAYOUT)}>
                      <div className="service_nav_title">{serviceNavElements.name}</div>
                      <div className="service_nav_description">{t("World of Universities")}</div>
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
          <HomeOffersCarousel offersData={headerData?.carousel} />
          <div className="school_service_cards_wrapper" onMouseMove={(event: any) => positionElement(event)} onMouseLeave={handleMouseLeave} />
          {schoolData?.data?.length > 0 && (
  <div className="service_card_title_wrapper">
    <div className="service_chip_with_circle" onClick={() => navigate(ROUTES.SCHOOLLAYOUT)}>
      <div className={school_background_circle_wrap}></div>
      <div className="service_chip_container">
        <img draggable="false" src={school} alt="Learn and Play" className="service_logo" />
        <div className="service_chip_label">{t("Schools")}</div>
      </div>
    </div>
    <div className={service_title_container_wrap}>
      <div className="service_title">
        {language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? schoolData.heading : schoolData.heading_ar}
      </div>
    </div>
    <div className="school_service_cards_wrapper">
      <HomeServiceCards cardType={HOMEPAGE.SERVICE_TYPE.SCHOOL} serviceData={schoolData.data} />
    </div>
  </div>
)}

          {tutorsData?.data?.length > 0 && (
            <div className="top_service_card_title_wrapper">
              <div className="tutor_background_circle_container"></div>
              <div className={`${top_service_card_title_container_wrap} top_service_card_title_container`}>
                <div className={`${top_service_title_wrap} ${isTutorContentOverlapping ? "image_content_overlap" : ""}`}>
                  <div className="service_chip_container" onClick={() => navigate(ROUTES.TUTORS)}>
                    <img draggable="false" src={tutor} alt="Learn and Play" className="service_logo" />
                    <div className="service_chip_label">{t("Tutors")}</div>
                  </div>
                  <div className="top_serive_title">
                    {language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? tutorsData?.heading : tutorsData?.heading_ar}
                  </div>
                  <div className="top_serive_description">
                    {language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? tutorsData?.description : tutorsData?.description_ar}
                  </div>
                </div>
                <div
                  className={`${wrapperClassName} ${isTutorContentOverlapping ? "tutor_content_overlap" : ""}`}
                  onMouseMove={(event: any) => positionElement(event)}
                  onMouseOver={handleTopServiceCursor}
                  onMouseLeave={(e: any) => {
                    handleMouseLeave();
                    handleTopServiceCursorLeave();
                  }}
                >
                  <TopServiceCards
                    isTutorContentOverlapping={isTutorContentOverlapping}
                    setIsTutorContentOverlapping={setIsTutorContentOverlapping}
                    serviceType={HOMEPAGE.SERVICE_TYPE.TUTOR}
                    serviceData={tutorsData.data}
                  />
                </div>
              </div>
            </div>
          )}
          {activitiesData?.data?.length > 0 && (
            <div className="service_card_title_wrapper">
              <div className={activities_background_circle_wrap}></div>
              <div className={service_title_container_wrap}>
                <div className="service_chip_container" onClick={() => navigate(ROUTES.ACTIVITYLAYOUT)}>
                  <img draggable="false" src={activities} alt="Learn and Play" className="service_logo" />
                  <div className="service_chip_label">{t("Activities")}</div>
                </div>
                <div className="service_title">
                  {language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? activitiesData?.heading : activitiesData?.heading_ar}
                </div>
                <div className="activities_service_cards_wrapper" onMouseMove={(event: any) => positionElement(event)} onMouseLeave={handleMouseLeave}>
                  <HomeServiceCards cardType={HOMEPAGE.SERVICE_TYPE.ACTIVITIES} serviceData={activitiesData.data} />
                </div>
              </div>
            </div>
          )}
          {trainersData?.data?.length > 0 && (
            <div className="top_service_card_title_wrapper">
              <div className="tutor_background_circle_container"></div>
              <div className={`${top_service_card_title_container_wrap} top_service_card_title_container`}>
                <div className={`${top_service_title_wrap} ${isActivitiesContentOverlapping ? "image_content_overlap" : ""}`}>
                  <div className="top_serive_title">
                    {language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? trainersData?.heading : trainersData?.heading_ar}
                  </div>
                  <div className="top_serive_description">
                    {language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? trainersData?.description : trainersData?.description_ar}
                  </div>
                </div>
                <div
                  className={`${wrapperClassName} ${isActivitiesContentOverlapping ? "tutor_content_overlap" : ""}`}
                  onMouseMove={(event: any) => positionElement(event)}
                  onMouseOver={handleTopServiceCursor}
                  onMouseLeave={(e: any) => {
                    handleMouseLeave();
                    handleTopServiceCursorLeave();
                  }}
                >
                  <TopServiceCards
                    isTutorContentOverlapping={isActivitiesContentOverlapping}
                    setIsTutorContentOverlapping={setIsActivitiesContentOverlapping}
                    serviceType={HOMEPAGE.SERVICE_TYPE.ACTIVITIES}
                    serviceData={trainersData.data}
                  />
                </div>
              </div>
            </div>
          )}
          {themeParksData?.data?.length > 0 && (
            <div className="service_card_title_wrapper">
              <div className={theme_park_background_circle_wrap}></div>
              <div className={service_title_container_wrap}>
                <div className="service_chip_container" onClick={() => navigate(ROUTES.THEMEPARK__HOMEPAGE)}>
                  <img draggable="false" src={ThemePark__gird} alt="Learn and Play" className="service_logo" />
                  <div className="service_chip_label">{t("Parks & Events")}</div>
                </div>
                <div className="service_title">
                  {language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? themeParksData?.heading : themeParksData?.heading_ar}
                </div>
                <div className="theme_park_service_cards_wrapper" onMouseMove={(event: any) => positionElement(event)} onMouseLeave={handleMouseLeave}>
                  <HomeServiceCards cardType={HOMEPAGE.SERVICE_TYPE.THEME_PARK} serviceData={themeParksData.data} />
                </div>
              </div>
            </div>
          )}
          {universityData?.data?.length > 0 && (
            <div className="service_card_title_wrapper university_label">
              <div className={university_background_circle_wrap}></div>
              <div className={service_title_container_wrap}>
                <div className="service_chip_container" onClick={() => navigate(ROUTES.UNIVERSITYLAYOUT)}>
                  <img draggable="false" src={University__gird} alt="Learn and Play" className="service_logo" width={20} />
                  <div className="service_chip_label">{t("Universities")}</div>
                </div>
                <div className="service_title">
                  {language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? universityData?.heading : universityData?.heading_ar}
                </div>
                <div className="university_service_cards_wrapper" onMouseMove={(event: any) => positionElement(event)} onMouseLeave={handleMouseLeave}>
                  <HomeServiceCards cardType={HOMEPAGE.SERVICE_TYPE.UNIVERSITY} serviceData={universityData.data} />
                </div>
              </div>
            </div>
          )}
          <div className="mobile_app_ad_wrapp">
            <img draggable="false" src={headerData?.footer} alt="Learn and Play" className="mobile_view_img" />
            <div className="mobile_app_links_wrapper">
              <button className="download_app">{t("Download app")}</button>
              <div className="mobile_app_ad_title">{t("App-solutely incredible!")}</div>
              <div className="mobie_app_ad_description">{t("Download our application, and let the magic happen")}</div>
              <div className="mobile_app_download_links">
                <img draggable="false" src={playStore} alt="Learn and Play" className="playstore_link" />
                <img draggable="false" src={appStore} alt="Learn and Play" className="app_store_link" />
              </div>
            </div>
          </div>
        </Suspense>
      )}
    </div>
  );
};

export default HomePage;


